function initContentCarousel() {
  document.querySelectorAll(".carouselbuttons button").forEach((button) => {
    button.addEventListener("click", (e) => {
      moveCarousel(e.currentTarget.dataset.target);
    });
  });
}

function moveCarousel(direction) {
  const logoStack = document.querySelector("#content-slider .logo-stack");
  const infoStack = document.querySelector("#content-slider .info-stack");
  const activeLogo =
    direction === "left" ? logoStack.firstChild : logoStack.lastChild;
  const activeInfo = document.getElementById(
    `info-tile-${activeLogo.dataset.licence}`,
  );

  activeLogo.style.zIndex = direction === "left" ? 26 : 28;
  if (direction === "left") {
    logoStack.append(activeLogo);
    infoStack.append(activeInfo);
  } else {
    logoStack.prepend(activeLogo);
    infoStack.prepend(activeInfo);
  }
  activeLogo.style.left =
    direction === "left"
      ? `-${activeLogo.offsetWidth + 50}px`
      : `${activeLogo.offsetWidth + 50}px`;
  setTimeout(() => {
    activeLogo.style.zIndex = direction === "left" ? 28 : 26;
    activeLogo.style.left = `0px`;
  }, 500);
  setTimeout(() => {
    activeLogo.style.zIndex = null;
    activeLogo.style.left = null;
  }, 1000);
}

window.addEventListener("load", initContentCarousel, false);
